import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 18,
  small: 14,
  xSmall: 11
};
const UserIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 5.5C12.2386 5.5 10 7.73858 10 10.5C10 13.2614 12.2386 15.5 15 15.5C17.7614 15.5 20 13.2614 20 10.5C20 7.73858 17.7614 5.5 15 5.5ZM15 6.5C17.2091 6.5 19 8.29086 19 10.5C19 12.7091 17.2091 14.5 15 14.5C12.7909 14.5 11 12.7091 11 10.5C11 8.29086 12.7909 6.5 15 6.5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M23.9951 21.7882C23.8845 19.4012 21.9143 17.5 19.5 17.5H10.5L10.2882 17.5049C7.90124 17.6155 6 19.5857 6 22V25H7V22L7.00518 21.808C7.10487 19.9643 8.63144 18.5 10.5 18.5H19.5L19.692 18.5052C21.5357 18.6049 23 20.1314 23 22V25H24V22L23.9951 21.7882Z",
        fill: "currentColor"
      }
    )
  );
};
UserIcon.iconName = "UserIcon";

export { UserIcon };
